import PropTypes from 'prop-types';

export const widgetConfigsPropTypes = PropTypes.shape({
  widget: PropTypes.shape({
    bgColor: PropTypes.string.isRequired,
    defaultFontType: PropTypes.string,
    customFontType: PropTypes.string,
  }).isRequired,
  progressBarBox: PropTypes.shape({
    pastEventIconColor: PropTypes.string,
    futureEventIconColor: PropTypes.string.isRequired,
    issueEventIconColor: PropTypes.string.isRequired,
  }).isRequired,
  mainBox: PropTypes.shape({
    bgColor: PropTypes.string.isRequired,
    fontColor: PropTypes.string.isRequired,
  }).isRequired,
  secondaryBox: PropTypes.shape({
    bgColor: PropTypes.string.isRequired,
    fontColor: PropTypes.string.isRequired,
  }).isRequired,
  tertiaryBox: PropTypes.shape({
    bgColor: PropTypes.string.isRequired,
    mainFontColor: PropTypes.string.isRequired,
    secondaryFontColor: PropTypes.string.isRequired,
  }).isRequired,
  parcelDetailsBox: PropTypes.shape({
    bgImage: PropTypes.string,
    lastEventDateFormat: PropTypes.string.isRequired,
  }).isRequired,
  trackingDetailsBox: PropTypes.shape({
    eventDateFormat: PropTypes.string.isRequired,
    eventTimeFormat: PropTypes.string.isRequired,
  }).isRequired,
  footerBox: PropTypes.shape({
    fontColor: PropTypes.string.isRequired,
    shouldShowPPLogo: PropTypes.bool,
  }).isRequired,
  merchantCustom: PropTypes.shape({
    noInfoDisplayType: PropTypes.string,
    noInfoDisplayMessage: PropTypes.string,
  }).isRequired,
});
